import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { styled } from '@mui/material';

export const ChevronIconStyled = styled(FontAwesomeIcon)(() => ({
  position: 'absolute',
  right: '8px',
  height: '14px',
  width: '13px',
}));
